/**
 * מזהה מתאם ל-audit: הזמנה / סשן / trace קיים / מזהה שנוצר (ללא הנחות עסקיות).
 * @param {Record<string, unknown>|null|undefined} meta
 * @returns {string}
 */
export function resolvePricingAuditTraceId(meta) {
  if (!meta || typeof meta !== "object") {
    return `gen-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  }
  const b = meta.bookingId != null ? String(meta.bookingId).trim() : "";
  if (b) return b;
  const s = meta.sessionId != null ? String(meta.sessionId).trim() : "";
  if (s) return s;
  const t = meta.traceId != null ? String(meta.traceId).trim() : "";
  if (t) return t;
  return `gen-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
